module.exports = __webpack_public_path__ + "static/img/kefu.551a03f0.png";